module.exports = __webpack_public_path__ + "static/cards-temp-5ad0dd32d7a8a6b36449ef2ed03a8ab1.png";